import { Component, OnInit, ViewChild, ElementRef, Input, OnDestroy } from '@angular/core';
import {StreamsService}  from "../../shared/services/streams.service";
import {PanelVisibilityService} from '../../shared/services/panel-visibility.service'
import {  NbToastrService, NbGlobalPosition, NbDialogService } from '@nebular/theme';
import {domain, protocol} from '../../shared/config';
 import {visibilityPanelAnimation} from '../../shared/classes/visibility-panel.animation'
 
@Component({
  selector: 'app-stream-download',
  templateUrl: './stream-download.component.html',
  styleUrls: ['./stream-download.component.scss'],
  animations: [visibilityPanelAnimation]
})
export class StreamDownloadComponent implements OnInit, OnDestroy {

	
	@Input() stream:any;
	@Input() rmhide:boolean = false;

	selectedResolution:any = null
	getLink$ = null
	deletingNow$ = null
	linkLoading: boolean = false
	deletingLoading: boolean = false
         @ViewChild("downloadModal", {static: false})
   	 downloadModal: any;

	downloadLinkBase = ''
	downloadSize = 0
 
	//resolutions:any = [] // [{index:0, resolution:1},{index:1, resolution:2},{index:2, resolution:3}]
	//size:any = 0
	
         domain: any = {
         name: domain, protocol
  }
	constructor(
	 public streamsService: StreamsService,
    	 private toastrService: NbToastrService,
    	 private dialogService: NbDialogService,
   	 public panelVisibility: PanelVisibilityService
	){}

	startDownload(){
		// alert(this.selectedResolution.index)
		//this.selectedResolution = null
		 //   this.dialogService.open(this.downloadModal,{hasScroll: true} )
		//return
          if(this.getLink$){this.getLink$.unsubscribe()}
		this.linkLoading = true


		 
	this.getLink$ = this.streamsService
    .getStreamDownloadLink(this.stream._id,this.selectedResolution)
	     .subscribe((data : any)=>{
	    
 


		 this.linkLoading = false
		this.selectedResolution = null

				//window.open(data.filePath, "_blank")

			this.downloadLinkBase = data.filePath
			 this.downloadSize = data.size
		    this.dialogService.open(this.downloadModal,{hasScroll: true} )

	    }, ()=>{

		    this.toastrService.show('','Сталася помилка',{
		      status: 'danger',
		      icon: '',
		      position: <NbGlobalPosition>'bottom-end'
			})

	     this.linkLoading = false
	    })
	    

	}
	downloadNow(){
		if(this.downloadLinkBase)
		window.open(this.downloadLinkBase, "_blank")
	}

	clearData(){
		this.stream.downloadInfo = {resolutions:[], size:0}
	}

	

  	deleteRecordModal(content){
		    this.dialogService.open(content,{hasScroll: true} )
	}

	deleteRecord(ref){
	       ref.close()

		this.deletingLoading = true

		//setTimeout(()=>{this.deletingLoading = false; this.clearData() },2000)
	  if(this.deletingNow$){this.deletingNow$.unsubscribe()}
		this.deletingNow$ = this.streamsService
    .deleteStreamRecord(this.stream._id)
	     .subscribe((data : any)=>{
	    	this.deletingLoading = false
  			if(data.message === 'ok'){
			this.clearData() 
			 this.toastrService.show('','Запис трансляції видалено',{
			      status: 'primary',
			      icon: '',
			      position: <NbGlobalPosition>'bottom-end'
				})

			} else {
 			this.toastrService.show('','Сталася помилка',{
			      status: 'danger',
			      icon: '',
			      position: <NbGlobalPosition>'bottom-end'
			})
			}

	    }, ()=>{

		   	    	this.deletingLoading = false
 		this.toastrService.show('','Сталася помилка',{
			      status: 'danger',
			      icon: '',
			      position: <NbGlobalPosition>'bottom-end'
			})
 
	    })
	    
		
	}


   showToastCopyClipboard(text){

    this.toastrService.show('',text,{
      status: 'primary',
      icon: '',
      position: <NbGlobalPosition>'bottom-end'
        })
   }



	 ngOnInit(): void {}


	 ngOnDestroy(): void {       

	  if(this.getLink$){this.getLink$.unsubscribe()}
	  if(this.deletingNow$){this.deletingNow$.unsubscribe()}
	 }


	
}
